import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { AscRepricingFormulaComponent } from './asc-repricing-formula/asc-repricing-formula.component';
import { AscCampaignRebudgetingModerateRiskFormulaComponent } from './asc-campaign-rebudgeting-formula/moderate-risk/asc-campaign-rebudgeting-moderate-risk-formula.component';
import { AscCampaignRebudgetingHighRiskFormulaComponent } from './asc-campaign-rebudgeting-formula/high-risk/asc-campaign-rebudgeting-high-risk-formula.component';
import { AscCampaignRebudgetingWellStockedFormulaComponent } from './asc-campaign-rebudgeting-formula/well-stocked/asc-campaign-rebudgeting-well-stocked-formula.component';
import { AscDayUntilStockOutFormulaComponent } from './asc-day-until-stock-out-formula/asc-day-until-stock-out-formula.component';

@NgModule({
  declarations: [
    AscRepricingFormulaComponent,
    AscCampaignRebudgetingModerateRiskFormulaComponent,
    AscCampaignRebudgetingHighRiskFormulaComponent,
    AscCampaignRebudgetingWellStockedFormulaComponent,
    AscDayUntilStockOutFormulaComponent,
  ],
  exports: [
    AscRepricingFormulaComponent,
    AscCampaignRebudgetingModerateRiskFormulaComponent,
    AscCampaignRebudgetingHighRiskFormulaComponent,
    AscCampaignRebudgetingWellStockedFormulaComponent,
    AscDayUntilStockOutFormulaComponent
  ],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class MathFormulaModule {}
